import React, { Component } from "react";
import PropTypes from "prop-types";
import { LicensedHeader } from "../../panel/header";
import styled from "styled-components";
import { cloud } from "@vitalsource/vstui/colors";
import TabsContainer from "./tabs";
import PanelBack from "../../panel/back";
import { t } from "../../../../core/translate";

const Wrapper = styled.div`
  background-color: ${cloud.getShade(2)};
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
`;

const BookPanel = ({ isbn }) => {
  return (
    <Wrapper>
      <PanelBack label={t("library.book-details")} />
      <LicensedHeader isbn={isbn} />
      <TabsContainer isbn={isbn} />
    </Wrapper>
  );
};

BookPanel.propTypes = {
  isbn: PropTypes.string.isRequired
};

export default BookPanel;
